// extracted by mini-css-extract-plugin
module.exports = {"chatWrapper":"chat_chatWrapper__rybly","modalWrapper":"chat_modalWrapper__WBNzh"};